export default "__VITE_PUBLIC_ASSET__232ef624__"